import request from "@/utils/request";

export function login(data) {
  return request({
    url: "/credit/accountLogin/0000/login",
    method: "post",
    data,
  });
}

export function modifyPwd(data) {
  return request({
    url: "/credit/account/2001001008/modifyPassword",
    method: "post",
    data,
  });
}

export function generateUuid(data) {
  return request({
    url: "/busUserController/0000/generateUuid",
    method: "get",
    data,
  });
}
export function queryToken(data) {
  return request({
    url: "/credit/busUserController/0000/queryToken",
    method: "get",
    params: data,
  });
}


export function forgetPassword(data) {
  return request({
    url: "/credit/account/0000/password",
    method: "post",
    data,
  });
}

export function smsVerCode(data) {
  return request({
    url: "/credit/account/0000/password",
    method: "get",
    params: data,
  });
}
